import { Directive, ElementRef, Input } from '@angular/core'
import type { Flow } from 'flowjs'

@Directive({
  selector: '[flowButton]',
})
export class FlowButtonDirective {
  @Input('flowButton') flow: Flow
  @Input() directory = false

  constructor (
    private element: ElementRef<HTMLElement>,
  ) { }

  ngOnInit () {
    this.flow.assignBrowse([this.element.nativeElement], this.directory)
  }
}
